const VUE_APP_API_HEMER_URL = document.querySelector("html").getAttribute("api_hermer_url");

export default VUE_APP_API_HEMER_URL